import { mapParticipantsPayloadDTOToParticipantsResponse } from "@/store/mappers/mapSixDetail";
import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";

export const fetchParticipantsThunk = createAppAsyncThunk(
  "sixDetail/fetchParticipants",
  async(sixId: string, { extra }) => {
    const participantsPayload = await extra.sixDetailService.fetchParticipants(sixId);
    return mapParticipantsPayloadDTOToParticipantsResponse(participantsPayload);
  }
);
